import { IUser } from "src/_cores/_interfaces/user.interface";

export class UserHelper {
  // /user/info returns userXxx-prefixed field names; normalize to the flat
  // IUser shape (role/fullName/id/...) that authStore.user consumers expect.
  public static mapUserInfo(raw: any): IUser {
    return {
      id: raw?.userId,
      mail: raw?.userMail ?? null,
      fullName: raw?.userFullName,
      joinDate: raw?.userJoinDate,
      address: raw?.userAddress ?? null,
      wardCode: raw?.userWardCode ?? null,
      districtCode: raw?.userDistrictCode ?? null,
      cityCode: raw?.userCityCode ?? null,
      phone: raw?.userPhone ?? null,
      role: raw?.roleKey ?? null,
      status: raw?.isActived,
      isSystemAccount: raw?.isSystemAccount,
      isOnline: raw?.isOnline,
      lastOnline: raw?.lastOnline,
      shops: raw?.shops ?? [],
    };
  }

  public static userIsActived(isActived: boolean) {
    if (isActived === true) {
      return { label: "Đã xác thực", color: "#1cc88a" };
    }
    return { label: "Đang xác thực", color: "yellow" };
  }
  public static getUserAddress(user: any) {
    let address = user.userAddress ?? "";
    if (user.userWardName) {
      address += `, ${user.userWardName}`;
    }
    if (user.userDistrictName) {
      address += `, ${user.userDistrictName}`;
    }
    if (user.userCityName) {
      address += `, ${user.userCityName}`;
    }
    return address;
  }
}
